import { render, staticRenderFns } from "./walletAddress.vue?vue&type=template&id=dbfe8a34&scoped=true"
import script from "./walletAddress.vue?vue&type=script&lang=js"
export * from "./walletAddress.vue?vue&type=script&lang=js"
import style0 from "./walletAddress.vue?vue&type=style&index=0&id=dbfe8a34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfe8a34",
  null
  
)

export default component.exports